import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/sendBox/ErrorMessage.module_built.css";
const classes = {"sendbox__error-message":"wa8yVAW_sendbox__error-message"}
export default classes

const _sendbox__error_message0 = classes["sendbox__error-message"]
export { _sendbox__error_message0 as "sendbox__error-message" }
